<template>
    <div class="toggle" v-on:click="toggleSort">
        <input type="hidden" name="sortBy" :value="sort" />
        <div class="toggle__indicator" :class="{
            'toggle__indicator--active': this.sort === 'latest'
        }"></div>
    </div>
</template>

<script>
export default {
    props: ["sortBy"],
    mounted() {
    },
    data() {
        return {
            sort: "latest"
        }
    },
    mounted() {
        this.sort = this.sortBy === '' ? "latest" : this.sortBy;
    },
    methods: {
        toggleSort: function () {
            if (this.sort === "relevance") {
                this.sort = "latest";
            } else {
                this.sort = "relevance";
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    document.getElementById("search-form").submit();
                }, 300);
            });
        }
    }
}
</script>

